import { Injectable } from '@angular/core';
import { HttpGeneralService, OrderParms, StockModuleSettingsParms } from '../../../shared';
import { RegPatServiceWorkFlow } from '../../../outpatient/interface/reg-pat-service-workflow';
import { RegPatService } from '../../../pricing/reg-pat-service/reg-pat-service';
import { CONFIG } from '../../../shared/config';
import { OrderDetails } from '../../order-stepper/shared/order-details';
import { OrderMaster } from '../../order-stepper/shared/order-master';

let orderReceptionUrl = CONFIG.baseUrls.ordering;
let stockTransUrl = CONFIG.baseUrls.StockTrans;

@Injectable()
export class OrderReceptionService {

  constructor(private httpGeneralService: HttpGeneralService) { }


  orderSearch(orderSearch: any) {
    return this.httpGeneralService.search(orderSearch, `${orderReceptionUrl}`);
  }
  orderDetail(orderSearch: any) {
    return this.httpGeneralService.search(orderSearch, `${orderReceptionUrl}/orderDetail`);
  }
  risGetRightClickAppCodes(rightClickAppCodesArr: OrderParms) {
    return this.httpGeneralService.search(rightClickAppCodesArr, `${orderReceptionUrl}/RisGetRightClickAppCodes`);
  }

  orderDetailCancel(orderSearch: any) {
    return this.httpGeneralService.add(orderSearch, `${orderReceptionUrl}/orderDetail/cancel`);
  }
  orderMasterCancel(orderSearch: any) {
    return this.httpGeneralService.add(orderSearch, `${orderReceptionUrl}/OrderMaster/cancel`);
  }
  orderDetailServices(orderSearch: any) {
    return this.httpGeneralService.search(orderSearch, `${orderReceptionUrl}/orderDetailServices`);
  }
  orderDetailSchedule(entity: any[]) {
    return this.httpGeneralService.addCollection(entity, `${orderReceptionUrl}/SerivceSchedule`);
  }
  orderServiceScheduled(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderReceptionUrl}/ScheduledOrders`);
  }

  orderPatientsHaveResult(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderReceptionUrl}/PatientsHaveResult`);
  }

  orderPatientResult(orderSearch: any) {
    return this.httpGeneralService.post(orderSearch, `${orderReceptionUrl}/PatientResult`);
  }

  orderDeliverResultSave(item: any[]) {
    return this.httpGeneralService.addCollection(item, `${orderReceptionUrl}/DeliverResult`);
  }

  getScheduledVPlaces(entity: any) {
    return this.httpGeneralService.search(entity, `${orderReceptionUrl}/scheduledRooms`);
  }

  workFlowServiceChangeStatus(newStatus: RegPatService) {
    return this.httpGeneralService.add(newStatus, `${orderReceptionUrl}/WorkFlow/ChangeStatus`);
  }

  workFlowServiceSearch(newStatus: RegPatServiceWorkFlow) {
    return this.httpGeneralService.post(newStatus, `${orderReceptionUrl}/WorkFlow/GetStatus`);
  }

  getRegPatOrderDetailsPrint(id: number) {
    return this.httpGeneralService.getWith(`${orderReceptionUrl}/GetRegPatOrderDetailsData/${id}`);
  }

  updateOrderDetail(OrderDetail: OrderDetails) {
    return this.httpGeneralService.update<OrderDetails>(OrderDetail.serial, OrderDetail, orderReceptionUrl);
  }
  updateOrderMaster(OrderMaster: OrderMaster) {
    return this.httpGeneralService.update<OrderMaster>(OrderMaster.serial, OrderMaster, `${orderReceptionUrl}/UpdateOrderMaster`);
  }
  getModuleSettings(parms: StockModuleSettingsParms) {
    return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }
  addGenSchReservedSlots(genSchReservedSlots: GenSchReservedSlots[]) {
    return this.httpGeneralService.addCollection(genSchReservedSlots, `${orderReceptionUrl}/GenSchReservedSlots`)
  }
  getGenSchReservedSlots(genSchReservedSlots: GenSchReservedSlots) {
    return this.httpGeneralService.post(genSchReservedSlots, `${orderReceptionUrl}/GenSchReservedSlotsLoad`)
  }
  deleteGenSchReservedSlots(id: number) {
    return this.httpGeneralService.delete(id, `${orderReceptionUrl}/deleteGenScheduleSlote`);
  }
  updateGenSchReservedSlots(genSchReservedSlots: GenSchReservedSlots) {
    return this.httpGeneralService.post<GenSchReservedSlots>(genSchReservedSlots, `${orderReceptionUrl}/updateGenScheduleSlote`);
  }

  /////////////////////////////////entity Types\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  private _entityType: number;
  private _secondEntityType: number;
  setEntityType(value: number) {
    this._entityType = value;
  }
  get entityType(): number {
    return this._entityType;
  }

  setSecondEntityType(value: number) {
    this._secondEntityType = value;
  }
  get secondEntityType(): number {
    return this._secondEntityType;
  }
}
export interface GenSchReservedSlots {
  id?: number,
  serial?: number,
  resourceId?: number,
  resourceType?: number,
  spareFlag?: number,
  schTime?: Date;
  endTimeSlot: Date;
  startTimeSlot: Date;
  scheduleType: number,
  overBookFlag: number,
  beneficiaryCode: number,
  beneficiaryType: number,
  serviceCode: number,
  beneficiaryAsTxt: string,
  notes: string
  dataStatus: number,
  genDaysNameEn?:string,
  regPatMedicalStepsSerial: number;
  priServiceStpMedicalStepId: number;
  regPatServiceSerial: number;
  servStatus: number;
  updateStatus: number;
  entityType?: number;
  ngbFromDate: Date;
  ngbToDate: Date;
  dateOnly: Date;
  docCode : number;
}